import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Instagram, Video, MessageCircle, Ghost } from 'lucide-react';
export function HubPage() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 300,
        damping: 24
      }
    }
  };
  const TikTokIcon = () => <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-250">
      <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z" data-id="element-251" />
    </svg>;
  const links = [{
    name: 'Instagram',
    icon: Instagram,
    url: 'https://www.instagram.com/aleks.szulc1/'
  }, {
    name: 'TikTok',
    icon: TikTokIcon,
    url: 'https://www.tiktok.com/@aleks.szulc1'
  }, {
    name: 'WhatsApp',
    icon: MessageCircle,
    url: 'https://wa.me/48536052998'
  }, {
    name: 'Snapchat',
    icon: Ghost,
    url: 'https://snapchat.com/t/fQHvQ0G6'
  }];
  return <main className="min-h-screen pt-28 pb-16 px-6 flex flex-col items-center" data-id="element-252">
      <div className="w-full max-w-md mx-auto" data-id="element-253">
        {/* Profile Header */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5
      }} className="flex flex-col items-center text-center mb-10" data-id="element-254">
          <div className="w-32 h-32 rounded-full overflow-hidden border-2 border-dark-border mb-6" data-id="element-255">
            <img src="https://cdn.magicpatterns.com/uploads/qRtEzBNdxoem4qabe1hiq8/IMG_7433.jpg" alt="Aleks Szulc" className="w-full h-full object-cover" data-id="element-256" />
          </div>
          <h1 className="text-5xl font-heading tracking-widest text-white mb-2" data-id="element-257">
            ALEKS SZULC
          </h1>
          <p className="text-gray-400 font-body text-sm tracking-wide uppercase" data-id="element-258">
            Kickboxer & Coach
          </p>
        </motion.div>

        {/* Links Container */}
        <motion.div variants={containerVariants} initial="hidden" animate="show" className="flex flex-col gap-4" data-id="element-259">
          {/* Featured CTA */}
          <motion.div variants={itemVariants} data-id="element-260">
            <Link to="/coaching" className="block w-full bg-accent-gold text-black font-heading tracking-wider text-xl py-5 px-6 rounded-xl text-center shadow-lg animate-pulse-glow hover:scale-[1.02] transition-transform" data-id="element-261">
              🥊 BOOK TRIAL SESSION — 50 PLN
            </Link>
          </motion.div>

          {/* Social Links */}
          {links.map(link => <motion.div key={link.name} variants={itemVariants} data-id="element-262">
              <a href={link.url} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-3 w-full bg-dark-card border border-dark-border hover:border-accent-blue py-4 px-6 rounded-xl text-white font-body font-medium transition-all hover:bg-dark-elevated" data-id="element-263">
                <link.icon className="w-5 h-5" data-id="element-264" />
                {link.name}
              </a>
            </motion.div>)}
        </motion.div>
      </div>
    </main>;
}